import { apiFetch } from '@nrdy-marketing-engine/api-fetch';

const removeLineItem = (cartId: string, catalogItemId: string) =>
  apiFetch(`/v1/carts/${cartId}/line-items/${catalogItemId}`, {
    method: 'DELETE',
  });

export default removeLineItem;
